import React, { useEffect } from "react";
import {
  Box,
  TextField,
  Grid,
  Typography,
  Autocomplete,
  Stack,
  Divider,
  InputLabel,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { serviceSlice } from "../../reducers/serviceReducer";
import { getOrgServiceType } from "../../services/services";
const Heading = (props) => {
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();
  const service = useSelector((state) => state.service);
  const init = async () => {
    try {
      const serviceData = await getOrgServiceType(
        props?.orgId,
        props.serviceId
      );
      dispatch(serviceSlice.actions.setService(serviceData));
    } catch (error) {}
  };
  return (
    <>
      <Stack direction="column">
        <Grid
          container
          spacing={2}
          style={{
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
          }}
        >
          <Grid item md={4} xs={12}>
            <Typography variant="h4">Catalog Item</Typography>
            <Autocomplete
              id="country-select"
              disabled
              // disablePortal
              // disabled={!customers?.length}
              ListboxProps={{ style: { maxHeight: "200px" } }}
              options={[
                { name: "Test Catalog Item 1" },
                { name: "Test Catalog Item 2" },
              ]}
              autoHighlight
              size="small"
              getOptionLabel={(option) => option?.name}
              margin="normal"
              name="country"
              limitTags={4}
              fullWidth
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option?.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                  margin="normal"
                  sx={{ mt: 1 }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off", // disable autocomplete and autofill
                  }}
                />
              )}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography variant="h4">Client</Typography>
            <Autocomplete
              id="country-select"
              disabled
              // disablePortal
              // disabled={!customers?.length}
              ListboxProps={{ style: { maxHeight: "200px" } }}
              options={[
                { name: "Test Client 1" },
                { name: "Test Client 2" },
              ]}
              autoHighlight
              size="small"
              getOptionLabel={(option) => option?.name}
              margin="normal"
              name="country"
              limitTags={4}
              fullWidth
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option?.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                  margin="normal"
                  sx={{ mt: 1 }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off", // disable autocomplete and autofill
                  }}
                />
              )}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography variant="h4">Location</Typography>
            <Autocomplete
              id="country-select"
              disabled
              // disablePortal
              // disabled={!customers?.length}
              ListboxProps={{ style: { maxHeight: "200px" } }}
              options={[
                { name: "Test Location 1" },
                { name: "Test Location 2" },
              ]}
              autoHighlight
              size="small"
              getOptionLabel={(option) => option?.name}
              margin="normal"
              name="country"
              limitTags={4}
              fullWidth
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option?.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                  margin="normal"
                  sx={{ mt: 1 }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off", // disable autocomplete and autofill
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mb: 1, mt: 2 }} />
        <Grid container spacing={2}>
          <Grid item md={4}>
            <InputLabel>
              {" "}
              <svg
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fillRule="evenodd">
                  <polygon
                    id="Shape"
                    fill="#EE2E24"
                    fillRule="nonzero"
                    points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                  ></polygon>
                </g>
              </svg>
              Service Category
            </InputLabel>
            <Autocomplete
              id="country-select"
              required
              disabled
              // disablePortal
              // disabled={!customers?.length}
              ListboxProps={{ style: { maxHeight: "200px" } }}
              options={[{ name: "Thermal Imaging" }, { name: "General" }]}
              autoHighlight
              size="small"
              getOptionLabel={(option) => option?.name}
              value={service.category}
              onChange={(value, newValue) =>
                dispatch(
                  serviceSlice.actions.handleChange({
                    name: "category",
                    value: newValue,
                  })
                )
              }
              margin="normal"
              name="country"
              limitTags={4}
              fullWidth
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option?.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                  margin="normal"
                  sx={{ mt: 1 }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off", // disable autocomplete and autofill
                  }}
                />
              )}
            />
          </Grid>
          <Grid item md={8}>
            <div>
              <InputLabel>
                {" "}
                <svg
                  width="16px"
                  height="16px"
                  viewBox="0 0 16 16"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fillRule="evenodd">
                    <polygon
                      id="Shape"
                      fill="#EE2E24"
                      fillRule="nonzero"
                      points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                    ></polygon>
                  </g>
                </svg>
                Service Name
              </InputLabel>
              <TextField
                sx={{ mt: 1 }}
                disabled
                size="small"
                required
                autoComplete="off"
                fullWidth
                placeholder="Type"
                margin="normal"
                name="service_name"
                type="service_name"
                variant="outlined"
                value={service.name}
                onChange={(e) =>
                  dispatch(
                    serviceSlice.actions.handleChange({
                      name: "name",
                      value: e.target.value,
                    })
                  )
                }
              />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default React.memo(Heading);
